import { AdaptiveSheet } from '../common/AdaptiveSheet';
import { PlanUpdatesView } from './PlanUpdatesView.web';

// Phone (and any non-desktop-shell caller) host for PlanUpdatesView — the
// desktop shell puts the same view in a CompanionPanel instead
// (DefensePlanPanel.web.tsx branches on useDesktopShell()).
export function PlanUpdatesSheet({
  visible,
  planId,
  onClose,
}: {
  visible: boolean;
  planId: string | null;
  onClose: () => void;
}) {
  return (
    <AdaptiveSheet isOpen={visible} onRequestClose={onClose} onDismiss={onClose} dialogWidth={480}>
      <AdaptiveSheet.ScrollView testID="plan-updates-sheet">
        <PlanUpdatesView planId={planId} onClose={onClose} />
      </AdaptiveSheet.ScrollView>
    </AdaptiveSheet>
  );
}
